import enLocale from 'element-ui/lib/locale/lang/en' //引入element语言包
//中文对应的英文
const en = {
  message: {
    info: {
      in1:"download",
        in2: "Quick transactions",
        in3:"Energy is credited in seconds",
        in4:"Longer lease term, up to 30 days",
        in5:"Larger scope, supporting a minimum rent of 32000 yuan",
        in6:"Support multi currency payment for purchase",
        in7:"Support DAPP payment and transfer leasing",
        in8:"Can reserve large amounts of energy",
        in9:"Remaining Rentable Energy",
        in10:"Energy leasing",
        in11:"Receiving address",
        in12:"Connect wallet to obtain address",
        in13:"Please select an address",
        in14:"Number of resource rentals",
        in15: "Estimated transferable USDT",
        in16: "Please enter the quantity",
        in17:"Resource rental time",
        in18:"be expected to",
        in19:"Expired and reclaimed by the system",
        in20:"payment",
        in21:"Ordering Information",
        in22:"energy",
        in23:"unit price",
        in24:"compare",
        in25:"Burn down the province",
        in26:"details",
        in27:"order amount",
        in28:"Order duration",
        in29:"Rental quantity",
        in30: "Save",
        in31:"discount",
        in32:"Receiving address",
        in33:"Wallet payment",
        in34:"Connect wallet payment",
        in35:"Address balance payment",
        in36:"recommend",
        in37:"Account balance payment",
        in38:"Address payment",
        in39:"Use on chain wallet for transfer and payment",
        in40:"Please make payment within the valid timeframe",
        in41:"The received amount needs to be consistent with the amount displayed below, otherwise the system cannot confirm it",
        in42:"Monitoring payment in progress",
        in43:"Copy payment address",
        in44: "Copy payment TRX quantity",
        in45:"Copy payment USDT quantity",
        in46:"Replicating Success",
        in47:"copy failed",
        in48:"pay success",
        in49:"Payment cancellation",
        in50:"Please connect TronLink wallet first",
        in51:"Frequent connection operations, please manually connect the wallet",
        in52:"The wallet connection has been cancelled",
        in53:"Transaction failed",
        in54:"Please enter the receiving address",
        in55:"Please select the rental time",
        in56:"Energy leasing",
        in57:"home page",
        in58: "Energy leasing",
        in59:"Rental record",
        in60:"API documentation",
        in61:"APP Download",
        in62:"Personal Center",
        in63:"log on",
        in64:"Change password",
        in65:"Log Out",
        in66:"Password",
        in67:"Confirm password",
        in68:"submit",
        in69:"Please input a password",
        in70:"Please enter your password again",
        in71:"The password entered twice is inconsistent",
        in72: "Energy trading platform",
        in73:"Cheap, convenient, fast, efficient, and safe",
        in74:"It is a TRON energy trading platform that provides TRON energy trading services, making TRON energy trading more convenient, safe, and fast",
        in75:"Platform ordering",
        in76:"Simple operation",
        in77:"Detailed data",
        in78:"Support QR code payment",
        in79:"Dapp payment",
        in80:"Go to place an order",
        in81:"Android place an order",
        in82:"IOS place an order",
        in83:"API place an order",
        in84:"What is energy? Is energy free?",
        in85:"There are three types of resources in the TRON network: bandwidth, energy, and storage. Thanks to the unique design model of wavefield, the storage resources in TRON networks are almost infinite. The TRON network introduces two quantifiable resources, Bandwidth Point and Energy. Where Bandwidth Point represents bandwidth resources and Energy represents energy resources.",
        in86: "We need to pay transaction fees through BTC and ETH when transferring funds on Bitcoin and Ethereum. The bandwidth and energy are consumed when transferring funds in the wavefield.",
        in87:"The rules established by Bitcoin and Ethereum are that token transfers need to be paid with BTC and ETH, while the rules established by Tron are paid with energy and bandwidth. There are two common types of tenants on the wave field (two common token formats): TRC-10 and TRC-20. Transferring TRX and TRC-10 tokens requires bandwidth consumption, while transferring TRC-20 tokens requires bandwidth and energy consumption.",
        in88:"If you don't know the token format, you can click on the token on the asset homepage, enter the transaction record interface, and then click on the top right corner to enter TRONSCAN to view its token format. For example, USDT on the market is in TRC-20 format",
        in89:" The energy in the wavefield account is not free, and TRX needs to be frozen to obtain energy. You can also rent energy from energy trading platforms. If there is 1 million energy in the account, it will gradually recover after use and reach the full 1 million within 24 hours. Freeze (lease) by default for at least 1 hour. When the account is unfrozen (lease expires) after 1 hour, the energy obtained through freezing (lease) will also be automatically reset to zero.",
        in90:"What is the use of energy?",
        in91:"Energy can mainly be used for consumption in the following scenarios (the consumption data below is an overview of on chain data, which is approximate, and the actual accurate consumption data needs to be queried by the blockchain browser after operation).",
        in92:"consume",
        in93:" TRC20 token consumes bandwidth and energy. For example, USDT is 20 tokens, and transferring one transaction requires 31895 energy and 345 bandwidth, which needs to be offset by approximately 13.39 TRX of energy and 0.345 TRX of bandwidth.",
        in94:" Smart contract consumption",
        in95:"Calling smart contracts requires bandwidth and energy consumption. For example, SUNSWAP buying and selling transactions are all smart contract interactions that require the consumption of energy and bandwidth in the account.",
        in96:"How to obtain energy?",
        in97:"Method 1: Burning TRX",
        in98:"If the account does not have enough energy, TRX will be automatically burned during the transfer to offset the bandwidth and energy required for the transfer. Compared to energy consumption, burning TRX is clearly not cost-effective.",
        in99:"Method 2: Freeze TRX",
        in100: "Click on the Energy/Bandwidth on the Asset homepage to enter the Tron Resource Management interface, select the type of resource you want to obtain, enter the number of TRX to be frozen, and obtain energy=frozen TRX/total energy frozen TRX obtained by the entire network * total energy limit. This is based on the fixed energy evenly distributed to all users by frozen TRX, and the frozen TRX can be thawed and retrieved after 3 days. If you have a large number of idle TRX, you can consider this method.",
        in101:"Method 3: Renting Energy",
        in102:"Energy leasing can be done through this platform to save transaction fees. Energy leasing does not require freezing a large amount of TRX or burning more TRX, and can also save at least 80% of transaction fees. Taking renting 1 million energy as an example, if TRX is directly burned, approximately 1266TRX needs to be burned in 3 days. Using this platform to rent 1 million energy only requires about 120TRX, saving 90% ≈ 1140TRX.",
        in103:"How to rent energy?",
        in104:"You can go through this platform",
        in105:"Renting energy",
        in106:"When will the energy be credited after successful payment?",
        in107:"After payment is completed, the energy will be credited to the account within 3 seconds at the fastest. Due to broadcast delays and other reasons, in rare cases, there may be a delay of 5 to 10 minutes.",
        in108:"How long can the energy be fully restored after use?",
        in109:"The energy will be fully restored within 24 hours after use.",
        in110:"Can the order be withdrawn?",
        in111:"After the order is generated, it is currently not supported to withdraw it",
        in112:"Tel group",
        in113:"customer service",
        in114: "copied successfully",
        in115:"copy failed",
        in116:"Please enter your email address",
        in117:"Please enter the verification code",
        in118:"Obtain verification code",
        in119:"Please enter your email address",
        in120:"Please input a password",
        in121:"sure",
        in122:"Password login",
        in123:"Verification code login",
        in124:"Please enter the correct email address",
        in125:"Verification code has been sent",
        in126:"Please input a password",
        in127:"Balance:",
        in128: "Recharge",
        in129:"Balance Details",
        in130:"order amount",
        in131:"Before the balance change",
        in132:"After the balance change",
        in133:"Order Number",
        in134:"Operating time",
        in135:"Please use the Wave Field Browser or mobile wallet to transfer funds.",
        in136:"Please verify your wallet address before transferring. If you cannot find the recharge amount after transferring, you can contact customer service to retrieve it.",
        in137:"The transfer amount must be greater than 1TRX.",
        in138:"The current address only supports TRX or USDT (TRC20) transfers.",
        in139:"place an order",
        in140:"Status inquiry",
        in141:"Configuration query",
        in142: "balance inquiry",
        in143:"order progress",
        in144:"Resource type",
        in145:"energy",
        in146:"Lease time",
        in147:"Completed quantity",
        in148:"Receiving address",
        in149:"Creation time",
        in150:"Recycling time",
        in151:"Proxy Hash",
        in152:"view",
        in153:"No data available at the moment",
        in154:"order",
        in155:"Payment countdown",
        in156: "Consumption TRX",
        in157:"Ordering interface",
        in158:"request data",
        in159:"account",
        in160:"password",
        in161:"Energy receiving address",
        in162:"Energy quantity, integer",
        in163:"The rental duration h represents hours d represents days, and only supports 1h, 1d, 3d, and more days of time",
        in164:"Return data: code=200 indicates success, others indicate failure",
        in165:"Order status can be queried by order number",
        in166:"Status query interface",
        in167:"Rental energy quantity",
        in168:"Order Number",
        in169:"Rental address",
        in170: "Unit price SUN",
        in171:"Rental duration",
        in172:"Payment amount trx",
        in173:"Renting Hash",
        in174:"Rental status: 1 Not rented, 2 Renting in progress, 3 Renting successful, 4 Renting failed",
        in175:"Configure query interface",
        in176:"Minimum order quantity",
        in177:"Current remaining energy limit",
        in178:"Can I place an order",
        in179:"1-hour unit price SUN",
        in180:"1 day unit price SUN",
        in181:"3-day unit price SUN",
        in182:"Other unit prices SUN",
        in183:"Balance query interface",
        in184: "Energy sublease",
        


      in185:"details",
      in186:"commission:",
      in187:"Withdrawal",
      in188:"Add sublease",
      in189:"energy switch",
      in190:"binding address",
      in191:"Order Number",
      in192:"Sublease configuration",
      in193:"Energy",
      in194:"Price",
      in195:"Maximum doubling",
      in196:"Order Notes",
      in197:"Creation time",
      in198:"operate",
      in199:"Synchronize to Robot",
      in200:"delete",
      in201:"Are you sure to delete?",
      in202:"prompt",
      in203:"sure",
      in204:"cancel",
      in205:"Bind transfer address",
      in206:"Please enter the resource receiving address",
      in207:"Sublease energy configuration",
      in208:"Quantity of energy",
      in209:"Please enter the energy quantity",
      in210:"TRX price",
      in211:"Please enter TRX price",
      in212:"Maximum doubling",
      in213:"Please enter the maximum multiplication factor",
      in214:"delete",
      in215:"increase",
      in216:"Order Notes",
      in217:"Please fill in the order remarks, optional",
      in218:"save",
      in219:"next step",
      in220: "Recommendation code, non mandatory",
      in221:"manage",
      in222:"Address",
      in223:"Commission balance details",
      in224:"add",
      in225:"Add Address",
      in226: "Please enter the address",

      in227:"System Announcement",
      in228: "Notice",
      
      in229:"Earning the price difference by subletting the balance in one's own account to others. Please set your address for receiving TRX in the above settings, and the price and quantity for each sublease are usually 65000 and 131000",
      in230:"Invite friends",
      in231:"My recommendation code",
      in232:"My recommended link",
      in233:"QR code invitation",
  
     
      },
  
   
  },
  ...enLocale
}
 
export default en;


// WEBPACK FOOTER //
// ./src/assets/i18n/langs/en_US.js